import { GoogleOAuthProvider } from '@react-oauth/google';
import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import App from './Commons/Layouts/App';
import store from './Commons/Store';
import './Commons/Extensions';
import './index.scss';
import './tailwind.css';

const GOOGLE_CLIENT_ID = '914816291724-gkq1mq4jnb0tvmmk43n07mgo05ojhd9g.apps.googleusercontent.com';

ReactDOM.render(
  <GoogleOAuthProvider clientId={GOOGLE_CLIENT_ID}>
    <Provider store={store}>
      <App />
    </Provider>
  </GoogleOAuthProvider>,
  document.getElementById('root'),
);
